import * as React from 'react';
import { Notifier } from '../notifier';

export type NotifierInstanceContextType = Notifier | undefined;

export const NotifierInstanceContext = React.createContext<NotifierInstanceContextType>(undefined);
NotifierInstanceContext.displayName = 'NotifierInstanceContext';
